import { policyRuleStates } from './hooks/usePolicyRules/constants'

export const policyRuleTabs = [
  { value: policyRuleStates.all, label: 'All' },
  { value: policyRuleStates.current, label: 'Current' },
  { value: policyRuleStates.scheduled, label: 'Scheduled' },
  { value: policyRuleStates.expired, label: 'Expired' },
]

export const emptyTabMessages = {
  [policyRuleStates.current]: 'No hay reglas actuales',
  [policyRuleStates.scheduled]: 'No hay reglas programadas',
  [policyRuleStates.expired]: 'No hay reglas expiradas',
}
